module.exports = __webpack_public_path__ + "public/SiteImages/clapDogs.gif?239f2b5e";